"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsFromPartial = exports.DEFAULT_PREFS = exports.Prefs = exports.TdsRejectionThreshold = exports.TdsRejectionThresholdOptions = exports.DealerIdOrUnassigned = exports.DealerId = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const Unit = __importStar(require("../../../../unit"));
const NAMESPACE = `Culligan.Device.Class.TanklessRo.Prefs`;
exports.DealerId = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[\x20-\x7E]{1,10}$/)).annotations({
    identifier: `${NAMESPACE}.DealerId`,
    title: 'Dealer ID',
    description: 'ID assigned to the Culligan dealer: 1 to 10 printable ASCII characters',
});
exports.DealerIdOrUnassigned = effect_1.Schema.transform(effect_1.Schema.Union(effect_1.Schema.Literal(''), exports.DealerId), effect_1.Schema.NullOr(effect_1.Schema.typeSchema(exports.DealerId)), {
    strict: true,
    decode: dealerId => (dealerId === '' ? null : dealerId),
    encode: dealerId => dealerId ?? '',
}).annotations({
    identifier: `${NAMESPACE}.DealerIdOrUnassigned`,
    description: 'Dealer ID, sent as an empty string by a unit that has no dealer assigned',
});
exports.TdsRejectionThresholdOptions = effect_1.Schema.Literal(75, 80, 85, 90).annotations({
    identifier: `${NAMESPACE}.TdsRejectionThresholdOptions`,
});
exports.TdsRejectionThreshold = exports.TdsRejectionThresholdOptions.pipe(Unit.Into(Unit.Compound.Percentage)).annotations({
    identifier: `${NAMESPACE}.TdsRejectionThreshold`,
    title: 'TDS Rejection Threshold',
    description: 'Rejection percentage below which the membrane failure error is triggered',
});
exports.Prefs = effect_1.Schema.Struct({
    dealerId: exports.DealerIdOrUnassigned,
    tdsRejectionThreshold: exports.TdsRejectionThreshold,
}).annotations({
    identifier: `${NAMESPACE}.Prefs`,
});
exports.DEFAULT_PREFS = exports.Prefs.make({
    dealerId: null,
    tdsRejectionThreshold: { _tag: 'Percentage', amount: 75 },
});
exports.PrefsFromPartial = (0, schema_1.StructFromPartial)(exports.DEFAULT_PREFS)(exports.Prefs).annotations({
    identifier: `${NAMESPACE}.PrefsFromPartial`,
});
//# sourceMappingURL=prefs.js.map